import { i18n, PREFIX } from "../i18n.js";
import { Decimal } from "decimal.js";

const makeQueryFromObject = data => {
  var query = "";
  for (var key in data) {
    if (data[key]) {
      query += key + "=" + data[key] + "&";
    }
  }
  return query.trim("&");
};
const getMediaUrl = (path, baseUrl) => {
  if (path.match(/^(#|\/\/|https?:\/\/|(mailto|tel|sms):)/gm)) {
    return path;
  }
  return baseUrl.rtrim("/") + "/" + path.ltrim("/");
};

const validateInput = (value, label, min = null, max = null) => {
  value = value.replace(",", ".");
  if (value == "") {
    return { valid: false, msg: i18n.t("Please input {label}!", { label }) };
  }
  if (isNaN(value)) {
    return {
      valid: false,
      msg: i18n.t("{label} must be a number!", { label })
    };
  }
  if (min && parseFloat(value) < min) {
    return {
      valid: false,
      msg: i18n.t("{label} must be greater than {min}", { label, min })
    };
  }
  if (max && parseFloat(value) > max) {
    return {
      valid: false,
      msg: i18n.t("{label} must be smaller than {max}", { label, max })
    };
  }
  return { valid: true, msg: "", number: parseFloat(value) };
};

const computeCustomFormatLabel = (system, width, height) => {
  if (system == "imperial") {
    return (
      i18n.t("Custom Format") + " (" + width + '"' + " x " + height + '"' + ")"
    );
  } else {
    return (
      i18n.t("Custom Format") + " (" + width + " x " + height + " " + "cm" + ")"
    );
  }
};

const getTranslatedMatrixValue = (value, prefix) => {
  const prefixed = prefix + value;
  let translated = i18n.t(prefixed);
  if (translated === prefixed) {
    translated = value;
  }
  return translated;
};
const isInRange = (value, ranges) => {
  let isInRange = false;
  for (const range of ranges) {
    if (value < range.minimum) {
      continue;
    }
    if (range.maximum && value > range.maximum) {
      continue;
    }
    if (range.increment) {
      const result = new Decimal(value).sub(range.minimum);
      if (result.div(range.increment).isInteger()) {
        isInRange = true;
        break;
      }
    } else {
      isInRange = true;
      break;
    }
  }
  return isInRange;
};
const getAllowedRangeString = ranges => {
  let rangesArray = [];
  for (const range of ranges) {
    if (range.minimum === range.maximum) {
      rangesArray.push(range.minimum);
    } else {
      let rangeString = "";
      if (range.maximum) {
        rangeString = i18n.t("[{min} - {max}]", {
          min: range.minimum,
          max: range.maximum
        });
      } else {
        rangeString = range.minimum;
        if (range.increment) {
          rangeString = i18n.t("[{min} - {max}]", {
            min: range.minimum,
            max: i18n.t("Infinity")
          });
        }
      }
      if (range.increment) {
        rangeString += i18n.t(" (increments of {inc})", {
          inc: range.increment
        });
      }
      rangesArray.push(rangeString);
    }
  }
  return rangesArray.join(", ");
};

const decodeJwtToken = token => {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    Buffer.from(base64, "base64")
      .toString("ascii")
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
  return JSON.parse(jsonPayload);
};

const isValidJwtToken = token => {
  var offset = 10;
  var decoded = decodeJwtToken(token);
  if (decoded && decoded.exp) {
    var current_time = new Date().getTime() / 1000;
    if (current_time + offset > decoded.exp) {
      return false;
    }
    return true;
  }
  return false;
};
export {
  makeQueryFromObject,
  validateInput,
  getMediaUrl,
  computeCustomFormatLabel,
  getTranslatedMatrixValue,
  isInRange,
  getAllowedRangeString,
  decodeJwtToken,
  isValidJwtToken
};
